import { render, staticRenderFns } from "./ToolPageBanner.vue?vue&type=template&id=48ff8476&scoped=true&"
import script from "./ToolPageBanner.vue?vue&type=script&lang=ts&"
export * from "./ToolPageBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPageBanner.vue?vue&type=style&index=0&id=48ff8476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff8476",
  null
  
)

export default component.exports